export default {
    menu: true
}
